import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const clsxMerge = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export const sectionHorizontalPaddingLeft = 'pl-3 sm:pl-8 lg:pl-16 xl:pl-32';
export const sectionHorizontalPadding = 'px-3 sm:px-8 lg:px-16 xl:px-32';
export const sectionContainerClassName = `max-w-screen-2xl m-auto w-full ${sectionHorizontalPadding}`;
